import React from 'react'

import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { CodigosTransaccionesConstant } from 'constants/index'

import { Portlet, Form, Button, Row, Col } from '_zari/core'
import Yup from '_zari/validation/_yup'

import { DownloadAxiosFile } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const portletBreadcrumbs = [
  { name: 'Asientos Contables', path: `/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}` },
  { name: 'Libros Electrónicos' },
  { name: 'Libro RVIE' }
]

export const ValidationSchema = Yup.object().shape({
  mes: Yup.string().length(2).required()
})

const FormatoLibroRVIE = () => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      mes: __adminContext.mesTrabajo || '',
      flagDescargaExcel: false
    }
  }, [__adminContext])

  const onSubmit = React.useCallback(
    async formData => {
      await AsientoContableService.descargarLibroElectronicoRVIE(formData)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Libro RVIE' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          {__adminContext.mesTrabajo && (
            <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
              {({ errors, touched, isSubmitting, handleSubmit, values }) => (
                <Form>
                  <Row>
                    <Col md={4}>
                      <FormGroups.MesContabilidadFormGroup
                        iError={errors.mes}
                        iTouched={touched.mes}
                        fIsSubmitting={isSubmitting}
                      />
                      <FormGroups.FlagDescargaExcelFormGroup
                        fIsSubmitting={isSubmitting}
                        iValue={values.flagDescargaExcel}
                      />
                      <Row>
                        <Col md={12} className='text-right'>
                          <Button disabled={isSubmitting} onClick={handleSubmit}>
                            {isSubmitting ? 'Descargando reporte ...' : 'Descargar'}
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          )}
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(FormatoLibroRVIE)
